export type ReleaseNoteApp = 'TMS' | 'OneView';

export type ReleaseNoteStatus = 'Draft' | 'Published';

export type ReleaseNote = {
  id: number;
  app: ReleaseNoteApp;
  versionLabel: string;
  status: ReleaseNoteStatus;
  publishedAt?: string | null;
  title: string;
  notes: string;
  createdAt: string;
};

export type LatestReleaseNote = {
  note?: ReleaseNote | null;
  hasHistory?: boolean;
};

export type ReleaseNoteHistory = {
  items: ReleaseNote[];
  hasMore: boolean;
};

export type SaveReleaseNote = {
  app: ReleaseNoteApp;
  versionLabel: string;
  title: string;
  notes: string;
  /** true publishes, false unpublishes, omitted saves without changing status. */
  publish?: boolean;
};

export const isReleaseNotePublished = (
  note?: Pick<ReleaseNote, 'status'> | null,
) => note?.status === 'Published';
